export const UserProfilePage = {
	name: "user-profile",
	displayName: "User Profile",
};

export const UserProfileFields = {
	Email: {
		name: "email",
		displayName: "Email",
		beName: "email",
	},
	FirstName: {
		name: "firstName",
		displayName: "First Name",
		beName: "first_name",
	},
	LastName: {
		name: "lastName",
		displayName: "Last Name",
		beName: "last_name",
	},
	DateOfBirth: {
		name: "dateOfBirth",
		displayName: "Date of Birth",
		beName: "date_of_birth",
	},
	Phone: {
		name: "phone",
		displayName: "Phone",
		beName: "phone",
	},
	MobilePhone: {
		name: "mobilePhone",
		displayName: "Mobile",
		beName: "mobile_phone",
	},
	Code: {
		name: "code",
		placeholder: "Enter Code",
	},
	Address: {
		name: "address",
		displayName: "Address",
		beName: "address",
	},
	City: {
		name: "city",
		displayName: "City",
		beName: "city",
	},
	State: {
		name: "state",
		displayName: "State",
		beName: "state",
	},
	Zip: {
		name: "zip",
		displayName: "Zip",
		beName: "zip",
	},
	Country: {
		name: "country",
		displayName: "Country",
		beName: "country",
	},
	Alias: {
		name: "alias",
		displayName: "Alias",
		beName: "alias",
	},
	Domain: {
		name: "domain",
		displayName: "",
		beName: "company_domain",
	},
	Status: {
		name: "status",
		displayName: "",
		beName: "status",
	},
	AgentId: {
		name: "agentId",
		displayName: "",
		beName: "id",
	},
	FusionAuthUserId: {
		name: "fusionAuthUserId",
		displayName: "",
		beName: "id",
	},
	IsManuallyLinkedWithFusionAuth: {
		name: "isManuallyLinkedWithFusionAuth",
		displayName: "",
		beName: "is_manually_linked_with_fusion_auth",
	},
	CompanyId: {
		name: "companyId",
		beName: "company_id",
	},
	CompanyName: {
		name: "companyName",
		beName: "company_name",
	},
	CompanyWhitelistedEmailDomains: {
		name: "companyWhitelistedEmailDomains",
		beName: "company_whitelisted_email_domains",
	},
};
